import Immutable from 'immutable';
import {User, Venue, Event, Entry} from './model';

function estimateEntryTimes(state) {
    // TODO - this function could account for people that have already played
    //        (rather than only using event.seconds_per_entry)
    //console.time('timeUpdate');
    const eventTime = {};
    const eventSecondsPerEntry = {};
    for (let [eventID, event] of state.get('events')) {
        eventTime[eventID] = event.start_time.clone();
        eventSecondsPerEntry[eventID] = event.seconds_per_entry;
    }

    state = state.update('entries', entries => entries.sortBy(e => e.draw).map(entry => {
        let currentTime = eventTime[entry.event].clone();

        if (entry.scratched) {
            return entry.set('start_time', currentTime);
        }

        entry = entry.set('start_time', currentTime);
        eventTime[entry.event].add(eventSecondsPerEntry[entry.event], 'seconds');

        return entry;
    }));

    //console.timeEnd('timeUpdate');

    return state;
}

export function dataLoad(state, {venues, events, entries}) {
    state = state.set('venues',  Immutable.OrderedMap(Object.keys(venues).map(id  => [id, new Venue(venues[id])])))
    state = state.set('events',  Immutable.OrderedMap(Object.keys(events).map(id  => [id, new Event(events[id])])))
    state = state.set('entries', Immutable.OrderedMap(Object.keys(entries).map(id => [id, new Entry(entries[id])])))
    state = state.set('loading', false);

    state = estimateEntryTimes(state);

    return state;
}

export function entryChanged(state, {entry}) {
    state = state.mergeIn(['entries', entry.id], entry);
    state = estimateEntryTimes(state);
    return state;
}

export function scratchEntry(state, {id}) {
    state = state.setIn(['entries', id, 'scratched'], true);

    state = estimateEntryTimes(state);

    return state;
}

export function unscratchEntry(state, {id}) {
    state = state.setIn(['entries', id, 'scratched'], false);

    state = estimateEntryTimes(state);

    return state;
}

export function login(state, {uid, name}) {
    return state.mergeIn(['user'], {uid, name});
}

export function logout(state) {
    return state.set('user', new User());
}

export function setUserRoles(state, {roles}) {
    return state.setIn(['user', 'roles'], Immutable.Set(roles));
}

export function addFavourite(state, {id}) {
    return state.updateIn(['user', 'favourites'], f => f.add(id));
}

export function removeFavourite(state, {id}) {
    return state.updateIn(['user', 'favourites'], f => f.remove(id));
}

export function setFavourites(state, {favourites}) {
    return state.setIn(['user', 'favourites'], Immutable.Set(favourites));
}



/** WEBPACK FOOTER **
 ** ./src/actions.js
 **/